import {AfterContentInit, Component, ContentChildren, Input, QueryList, ChangeDetectionStrategy} from '@angular/core';
import {CollapserItemComponent} from '../collapser-item/collapser-item.component';

@Component({
  selector: 'app-collapser',
  imports: [],
  templateUrl: './collapser.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './collapser.component.scss'
})
export class CollapserComponent implements AfterContentInit {
  @Input() maxItems = 5;
  @ContentChildren(CollapserItemComponent) items!: QueryList<CollapserItemComponent>;

  canToggle = false;
  expanded = false;

  ngAfterContentInit(): void {
    if (this.maxItems < this.items.length) {
      this.canToggle = true;
    }

    setTimeout(() => {
      this.refresh();
    });
  }

  refresh(): void {
    let i = 0;
    this.items.forEach((item: CollapserItemComponent) => {
      if (this.expanded) {
        item.visible = true;
      } else {
        item.visible = i < this.maxItems;
      }
      i++;
    });
  }

  canExpand(): boolean {
    return this.canToggle && !this.expanded;
  }

  canCollapse(): boolean {
    return this.canToggle && this.expanded;
  }

  expand(): void {
    this.expanded = true;
    this.refresh();
  }

  collapse(): void {
    this.expanded = false;
    this.refresh();
  }

  getCount(): number {
    return this.items.length;
  }
}
